import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiSmartphone, FiArrowRight, FiCpu, FiZap, FiAlertCircle } from 'react-icons/fi';
import { sendOtp } from '../../redux/services/authService/authApi';

import {
  warningToast,
  errorToast,
  infoToast,
  successToast,
} from '../../Utils/toast';
import './Login.css';
import yaanjiLogo from '../../assets/image/yaanji-logo.png';

export default function Login() {
  const navigate = useNavigate();
  const [mobile, setMobile] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const handleSendOtp = async (e) => {
    e.preventDefault();
    setError('');
    if (!/^\d{10}$/.test(mobile)) {
      setError('Please enter a valid 10-digit mobile number');
      warningToast('Please enter a valid 10-digit mobile number');
      return;
    }
    setLoading(true);
    try {
      const res = await sendOtp(mobile);
      if (res.otp) {
        infoToast(`OTP: ${res.otp}`);
      }
      successToast(res.message || 'OTP sent successfully');
      navigate('/otp-verify', {
        state: {
          mobile,
          isNewUser: res.is_new_user,
        },
      });
    } catch (err) {
      const msg = err.message || 'Failed to send OTP';
      setError(msg);
      errorToast(msg);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="login-hud">
      <div className="login-hud-grid"></div>
      <div className="login-hud-orb login-orb-1"></div>
      <div className="login-hud-orb login-orb-2"></div>
      <div className="login-hud-orb login-orb-3"></div>
      <div className="login-hud-scan"></div>
      <span className="login-particle p1"></span>
      <span className="login-particle p2"></span>
      <span className="login-particle p3"></span>

      <div className="login-hud-wrapper">
        {/* LEFT */}
        <div className="login-hud-left">
          <div className="login-hud-brand">
            {/* <div className="login-hud-chip">
              <span className="login-hud-chip-dot"></span>
              <FiCpu />
            </div> */}
            <div>
              {/* <strong>Yaanji</strong> */}
              {/* <small>AI · CRM · AUTOMATION</small> */}
            </div>
          </div>
          <div className="login-hud-hero">
            <div className="login-robot">
              <div className="login-robot-ring login-robot-ring-1"></div>
              <div className="login-robot-ring login-robot-ring-2"></div>
              <div className="login-robot-head">
                <div className="login-robot-eye login-eye-left"><span className="eye-pupil"></span></div>
                <div className="login-robot-eye login-eye-right"><span className="eye-pupil"></span></div>
                <div className="login-robot-mouth">
                  <span></span><span></span><span></span><span></span><span></span>
                </div>
                <div className="login-robot-antenna"><span className="antenna-tip"></span></div>
              </div>
            </div>

            <h2 className="login-hud-title">
              <FiZap />
              <span className="gradient-text">WELCOME TO Yaanji</span>
            </h2>
            <p className="login-hud-subtitle">
              Access your AI calling engine, real-time analytics, and lead management console.
            </p>
          </div>

          <div className="login-hud-footer">
            © 2026 Yaanji - Powered by A2 Technosoft
          </div>
        </div>

        {/* RIGHT */}
        <div className="login-hud-right">

          <div className="login-hud-logo">
            <img src={yaanjiLogo} alt="Yaanji Logo" />
             {/* <img src="/yaanji-logo.png" alt="Yaanji Logo" /> */}
          </div>

          <div className="login-hud-form-wrap">
            <div className="login-hud-form-glow"></div>

            <div className="login-hud-form-head">
              <h1>SYSTEM ACCESS</h1>
              <p>Enter mobile number to receive OTP</p>
            </div>

            {error && (
              <div className="login-hud-error">
                <FiAlertCircle />
                <span>{error}</span>
              </div>
            )}

            <form className="login-hud-form" onSubmit={handleSendOtp}>
              <label className="login-hud-field">
                <span className="login-hud-label">MOBILE NUMBER</span>
                <div className="login-hud-input-wrap">
                  <FiSmartphone className="login-hud-ico" />
                  <input
                    type="tel"
                    placeholder="Enter 10-digit mobile"
                    value={mobile}
                    maxLength={10}
                    onChange={(e) => setMobile(e.target.value.replace(/\D/g, '').slice(0, 10))}
                    autoComplete="tel"
                  />
                </div>
              </label>

              <button
                type="submit"
                className="login-hud-submit"
                disabled={loading}
              >
                {loading ? (
                  <span className="login-hud-spinner"></span>
                ) : (
                  <>
                    <FiZap />
                    <span>SEND OTP</span>
                    <FiArrowRight />
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}